import { EnvConfig } from '@config';
import { WebIncident } from 'types/webIncident';

import { useFetch, UseFetchOptions } from './useFetch';

const kickStuckApiBaseUrl = EnvConfig.drillx_common_backend || '';

const useFetchKickStuckApiEndpoint = <ResponseType>(
  endpoint: string,
  options: UseFetchOptions<ResponseType> = {},
) => useFetch<ResponseType>(kickStuckApiBaseUrl + endpoint, options);

export const useAutoFetchActiveWebIncidents = () => {
  return useFetchKickStuckApiEndpoint<WebIncident[]>(`/web-incidents/active`, {
    autoFetch: true,
  });
};
